"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var AbstractValidationPlugin_1 = __importDefault(require("./AbstractValidationPlugin"));
var ContactformTypes_1 = require("../../types/ContactformTypes");
console.debug('INFO FileValidatonPlugin.ts loaded');
var FileValidationPlugin = /** @class */ (function (_super) {
    __extends(FileValidationPlugin, _super);
    function FileValidationPlugin(field) {
        var _this = _super.call(this, field) || this;
        _this.field = field;
        _this.MAX_FILE_SIZE = 7500000;
        _this.attr = 'data-file-error-message';
        _this.bulkEmail = false;
        _this.allowedFileCount = 10;
        _this.bulkEmail = _this.field.parentElement.dataset.bulkemail
            ? JSON.parse(_this.field.parentElement.dataset.bulkemail)
            : false;
        _this.allowedFileCount = _this.field.parentElement.dataset.maxuploads ? parseInt(_this.field.parentElement.dataset.maxuploads) : 10;
        return _this;
    }
    FileValidationPlugin.prototype.runCustomValidation = function () {
        var allowedFileTypes = this.field.getAttribute('accept').split(',');
        if ('files' in this.field) {
            var files = this.field.files || [];
            var totalSize = this.field.dataset.totalFilesize ? parseInt(this.field.dataset.totalFilesize) : 0;
            var currentFileCount = this.field.dataset.filecount ? parseInt(this.field.dataset.filecount) : 0;
            var totalFileCount = files.length + currentFileCount;
            var fileTypeMatch = true;
            var fileSizeMismatch = void 0;
            for (var _i = 0, files_1 = files; _i < files_1.length; _i++) {
                var file = files_1[_i];
                totalSize += file.size;
                fileTypeMatch = file.type && allowedFileTypes.includes(file.type);
                fileSizeMismatch = file.size > this.MAX_FILE_SIZE;
            }
            var conditionList = [
                {
                    condition: totalFileCount > this.allowedFileCount,
                    attr: ContactformTypes_1.FileErrorAttributeName.FILECOUNT,
                },
                {
                    condition: !this.bulkEmail && !fileTypeMatch && totalSize >= this.MAX_FILE_SIZE,
                    attr: ContactformTypes_1.FileErrorAttributeName.FILE,
                },
                {
                    condition: (this.bulkEmail && fileSizeMismatch) || (!this.bulkEmail && totalSize >= this.MAX_FILE_SIZE),
                    attr: ContactformTypes_1.FileErrorAttributeName.FILESIZE,
                },
                {
                    condition: !fileTypeMatch,
                    attr: ContactformTypes_1.FileErrorAttributeName.FILEFORMAT,
                },
                {
                    condition: totalSize === 0 && this.field.hasAttribute('requiredFile'),
                    attr: ContactformTypes_1.FileErrorAttributeName.NOFILE,
                },
            ];
            this.check(conditionList);
        }
    };
    FileValidationPlugin.prototype.check = function (conditionList) {
        this.field.setCustomValidity('');
        for (var _i = 0, conditionList_1 = conditionList; _i < conditionList_1.length; _i++) {
            var c = conditionList_1[_i];
            if (c.condition) {
                this._setMessageAttribute(c.attr);
                this.field.setCustomValidity('Invalid field.');
            }
        }
    };
    FileValidationPlugin.prototype.isValid = function () {
        this.runCustomValidation();
    };
    FileValidationPlugin.prototype._getMessageAttribute = function () {
        return this.attr;
    };
    FileValidationPlugin.prototype._setMessageAttribute = function (attr) {
        this.attr = attr;
    };
    FileValidationPlugin.prototype._getDefaultMessage = function () {
        return 'Your input does not match the requirements.';
    };
    return FileValidationPlugin;
}(AbstractValidationPlugin_1.default));
exports.default = FileValidationPlugin;
